module.exports = __webpack_public_path__ + "static/media/wdqb_btc.c5addce7.svg";